import {Fleet} from "../models/fleet.model";

function translatePlaceToLocation(selectedFleet:Fleet|null, place: any){

  let postcode = 'xxxx-yyyy';
  let city = '';
  let state = '';
  let country = '';

  // Extract address components from place object
  if (place && place.address_components && place.address_components.length > 0) {
    let streetNumber = '';
    let route = '';

    // Process each address component
    place.address_components.forEach((component: any) => {
      const types = component.types;

      if (types.includes('street_number')) {
        streetNumber = component.long_name.trim();
      } else if (types.includes('route')) {
        route = component.long_name.trim();
      } else if (types.includes('postal_code')) {
        postcode = postcode.replace('xxxx', component.short_name.trim());
      } else if (types.includes('postal_code_suffix')) {
        postcode = postcode.replace('yyyy', component.short_name.trim());
      } else if (types.includes('locality')) {
        city = component.long_name.trim();
      } else if (types.includes('administrative_area_level_1')) {
        state = component.short_name.trim();
      } else if (types.includes('country')) {
        country = component.long_name.trim();
        if (component.long_name === 'United States') {
          country = 'USA';
        }
      }
    });

    postcode = postcode.replace('-yyyy', '');
    postcode = postcode.replace('xxxx', '');

    // Combine street number and route to form the address
    const address = (streetNumber && route) ?
      `${streetNumber} ${route}` :
      (streetNumber || route || place.formatted_address || '');

    const label = `${address}, ${city}, ${state}, ${country}`;

    return {
      fleet: selectedFleet ? selectedFleet.id : '',
      geocode: {
        type: 'Point',
        coordinates: place && place.geometry && place.geometry.location ?
          [place.geometry.location.lng(), place.geometry.location.lat()] :
          [0, 0]
      },
      address: address,
      postcode: postcode,
      city: city,
      state: state,
      country: country,
      label: label,
    };

  }

  return null;
}

export {translatePlaceToLocation};
